import type { Attachment } from '@/utils/types'

const isPdf = (fileType: string, fileName?: string) => {
  const normalisedFileType = fileType.toLowerCase().split(';')[0].trim()

  return (
    normalisedFileType === 'application/pdf' ||
    Boolean(fileName && /\.pdf$/i.test(fileName))
  )
}

const isPptx = (fileType: string) =>
  fileType ===
  'application/vnd.openxmlformats-officedocument.presentationml.presentation'

const isDocx = (fileType: string) =>
  fileType ===
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document'

export const isPdfBackedAttachment = (
  attachment: Attachment | null
): boolean => {
  if (!attachment) return false

  return (
    isPdf(attachment.fileType, attachment.fileName) ||
    isPptx(attachment.fileType) ||
    isDocx(attachment.fileType)
  )
}

/**
 * Prefer the browser's native PDF renderer outside desktop Chrome, where the
 * custom PDF.js viewers show rendering artifacts in Safari and mobile-width
 * contexts.
 */
export const detectNativePdfRenderer = (
  attachment: Attachment | null,
  userAgent: string,
  viewportWidth: number
): boolean => {
  if (!isPdfBackedAttachment(attachment)) {
    return false
  }

  const isSafari =
    /Safari/i.test(userAgent) &&
    !/Chrome|Chromium|CriOS|Edg|OPR|Opera|Firefox|FxiOS/i.test(userAgent)
  const isChromeLike = /Chrome|Chromium|CriOS/i.test(userAgent)
  const isMobileLike =
    /Mobile|Android|iPhone|iPad|iPod|CriOS/i.test(userAgent) ||
    viewportWidth <= 1024

  return !(isChromeLike && !isMobileLike && !isSafari)
}
